import { render, staticRenderFns } from "./SubscribeBridge.vue?vue&type=template&id=db80138a&scoped=true"
import script from "./SubscribeBridge.vue?vue&type=script&lang=js"
export * from "./SubscribeBridge.vue?vue&type=script&lang=js"
import style0 from "./SubscribeBridge.vue?vue&type=style&index=0&id=db80138a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db80138a",
  null
  
)

export default component.exports